module.exports = __webpack_public_path__ + "static/media/world.eb23f0a3.gif";